import { ref } from 'vue'
// will be called on risks pane when a threat is added to risk
export const refreshThreatCallback = ref<Function>()
